import type { FormEvent } from "react";
import type { ConfigEntry } from "./types";
import styles from "./workflow.module.scss";

const KNOWN_NAMESPACES = ["databases", "apis", "slack", "agent"];

interface WorkflowConfigEntryFormProps {
  editingEntry: ConfigEntry | null;
  formNs: string;
  formCustomNs: string;
  formKey: string;
  formValue: string;
  formEncrypted: boolean;
  saving: boolean;
  onSubmit: (e: FormEvent) => void;
  onCancel: () => void;
  onNsChange: (v: string) => void;
  onCustomNsChange: (v: string) => void;
  onKeyChange: (v: string) => void;
  onValueChange: (v: string) => void;
  onEncryptedChange: (v: boolean) => void;
}

export const WorkflowConfigEntryForm = ({
  editingEntry, formNs, formCustomNs, formKey, formValue, formEncrypted, saving,
  onSubmit, onCancel, onNsChange, onCustomNsChange, onKeyChange, onValueChange, onEncryptedChange,
}: WorkflowConfigEntryFormProps) => (
  <form className={styles.configForm} onSubmit={onSubmit}>
    <h3>{editingEntry ? "Edit Configuration" : "Add Custom Configuration"}</h3>
    <div className={styles.configFormGrid}>
      <label htmlFor="config-form-namespace" className={styles.configFormField}>
        <span>Namespace</span>
        <select id="config-form-namespace" value={formNs} onChange={e => onNsChange(e.target.value)}>
          {KNOWN_NAMESPACES.map(key => (
            <option key={key} value={key}>{key.charAt(0).toUpperCase() + key.slice(1)}</option>
          ))}
          <option value="__custom__">Custom...</option>
        </select>
      </label>
      {formNs === "__custom__" && (
        <label htmlFor="config-form-custom-ns" className={styles.configFormField}>
          <span>Custom Namespace</span>
          <input
            id="config-form-custom-ns"
            type="text"
            value={formCustomNs}
            onChange={e => onCustomNsChange(e.target.value)}
            placeholder="e.g. monitoring"
            required
          />
        </label>
      )}
      <label htmlFor="config-form-key" className={styles.configFormField}>
        <span>Key</span>
        <input
          id="config-form-key"
          type="text"
          value={formKey}
          onChange={e => onKeyChange(e.target.value)}
          placeholder="e.g. snowflake_account"
          required
          disabled={!!editingEntry}
        />
      </label>
      <label htmlFor="config-form-value" className={styles.configFormField}>
        <span>Value</span>
        <input
          id="config-form-value"
          type={formEncrypted ? "password" : "text"}
          value={formValue}
          onChange={e => onValueChange(e.target.value)}
          placeholder={editingEntry?.encrypted ? "Enter new value to update" : "e.g. xy12345.us-east-1"}
        />
      </label>
      <label htmlFor="config-form-encrypted" className={styles.configFormCheckbox}>
        <input
          id="config-form-encrypted"
          type="checkbox"
          checked={formEncrypted}
          onChange={e => onEncryptedChange(e.target.checked)}
        />
        <span>Encrypted (sensitive value)</span>
      </label>
    </div>
    <div className={styles.configFormActions}>
      <button type="button" className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
      <button type="submit" className={styles.saveBtn} disabled={saving}>
        {saving ? "Saving..." : "Save"}
      </button>
    </div>
  </form>
);
